import { Circle } from "lucide-react";
import { Check } from "@/components/animate-ui/icons/check";
import { cn } from "@/lib/utils";
import { useOnboardingStore } from "@/stores/onboarding-store";

export function ChecklistScreen() {
	const { checklist, toggleChecklistItem } = useOnboardingStore();

	return (
		<div className="space-y-6">
			{/* Heading */}
			<div className="space-y-3 text-center">
				<h2 className="text-2xl font-semibold tracking-tight">Ready to get started?</h2>
				<p className="text-base text-muted-foreground">
					Complete these steps to make the most of m8tes
				</p>
			</div>

			{/* Checklist items */}
			<div className="space-y-3">
				{checklist.map((item) => (
					<button
						key={item.id}
						type="button"
						className="flex w-full items-start gap-4 cursor-pointer rounded-lg border bg-card p-4 hover:bg-muted/50 transition-colors text-left"
						onClick={() => toggleChecklistItem(item.id)}
					>
						{/* Checkbox icon */}
						<div className="mt-0.5">
							{item.completed ? (
								<div className="flex size-5 items-center justify-center rounded-full bg-primary text-primary-foreground">
									<Check className="size-3.5" strokeWidth={3} />
								</div>
							) : (
								<Circle className="size-5 text-muted-foreground/60" />
							)}
						</div>

						{/* Label */}
						<p
							className={cn(
								"flex-1 text-sm font-medium leading-tight",
								item.completed ? "text-muted-foreground/60 line-through" : "text-foreground"
							)}
						>
							{item.label}
						</p>
					</button>
				))}
			</div>
		</div>
	);
}
